"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = void 0;
var Roles;
(function (Roles) {
    Roles["Manager"] = "manager";
    Roles["Admin"] = "admin";
    Roles["CallmartOSP"] = "callmart_osp";
    Roles["CallmartTEF"] = "callmart_tef";
    Roles["CallmartForecast"] = "callmart_forecast";
    Roles["CallmartBudget"] = "callmart_budget";
    Roles["CallmartWFM"] = "callmart_wfm";
    Roles["CallmartWTM"] = "callmart_wtm";
    Roles["M2M"] = "m2m";
    Roles["Any"] = "any";
    Roles["AnyUser"] = "any_user";
})(Roles || (exports.Roles = Roles = {}));
